import React, {useState, useRef, useEffect} from 'react';
import styled from "styled-components";
import ModalLayout from "@layouts/modal";
import {reportProperty} from "@models/property";
import Captcha from "@molecules/auth/captcha";
import {isEmpty} from "@helpers/helpers";
import Radio from "@atoms/radio";
import Textarea from "@atoms/textarea";
import ButtonBase from "@atoms/button.base";
import StatusGif from "@atoms/status_gif";
import CircleLoading from "@molecules/lotties/circle_loading";
import {toEnglishNumber} from "@helpers/numbers";


const PropertyReport = ({property_id, show, setShow}) => {
    const submitRef = useRef('');
    const errorRef = useRef('');
    const options = [
        {name: 'dealt', label: 'ملک واگذار شده', checked: false},
        {name: 'wrong_price', label: 'قیمت اشتباهه', checked: false},
        {name: 'irrelevant_media', label: 'عکس‌ها مرتبط نیست', checked: false},
        {name: 'no_answer', label: 'کسی پاسخگو نبود', checked: false},
        {name: 'wrong_info', label: 'توضیحات ناقصه', checked: false},
    ];
    const [report, setReport] = useState({type: '', message: '', captcha_code: ''});
    const [captcha, setCaptcha] = useState({});
    const [reportStatus, setReportStatus] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        setReportStatus({text: '', status: ''});
        setCaptcha({token: '', error: ''});
        setReport({type: '', message: '', captcha_code: ''});
    }, [show]);

    const handleChange = (e, field) => {
        let value = e.target.value;
        value = toEnglishNumber(value);

        if (!isEmpty(errorRef.current)) {
            errorRef.current.classList.add('d-none');
        }

        setReport(state => ({
            ...state,
            [field]: value
        }))
    };

    const handleSubmitReport = () => {
        if (!isEmpty(property_id) && !isEmpty(report.type)) {
            setSubmitLoading(true);

            const param = {
                property_id: property_id,
                type: report.type,
                description: report.message,
                captcha_code: report.captcha_code,
            };

            reportProperty(param).then(result => {
                setReportStatus({
                    text: 'از اینکه در بروزرسانی آگهی‌های 2نبش به ما کمک می‌کنید از شما ممنونیم.',
                    status: 'done',
                });
                setSubmitLoading(false);
            }).catch(error => {
                setSubmitLoading(false);

                if (!isEmpty(error) && !isEmpty(error.captcha_token)) {
                    setCaptcha({token: error.captcha_token, error: ''});
                } else {
                    setReportStatus({
                        text: 'انگار خطایی رخ داد لطفا دوباره تلاش کنید.',
                        status: 'cancel',
                    });
                }
            });
        } else {
            handleErrors()
        }
    };

    const handleErrors = () => {
        if (!isEmpty(errorRef.current)) {
            errorRef.current.classList.remove('d-none');
        }
    };

    return (
        <ModalLayout show={show} setShow={setShow} modalDialogClass="modal-sm report-modal" dialogBodyClassName="px-0">
            <div className="text-center mt-8 mt-lg-0">
                <h3 className="h2">گزارش مشکل</h3>

                <Body className={"px-24 px-lg-32 pb-40 pb-md-0 " + (isEmpty(reportStatus.status) ? ' pt-24' : '')}>

                    {
                        (isEmpty(reportStatus.status)) ?
                            <React.Fragment>
                                {
                                    options.map((item, key) =>
                                        <Radio
                                            name="report_types"
                                            id={item.name}
                                            value={item.name}
                                            label={item.label}
                                            checked={(item.name === report.type)}
                                            onChange={(e) => handleChange(e, 'type')}
                                            className={(key > 0) ? "mt-16" : ''}
                                        />
                                    )
                                }

                                <ErrorDiv ref={errorRef} className="d-none text-danger-text text-right mt-16">لطفا یک گزینه رو انتخاب کنید.</ErrorDiv>

                                <Textarea
                                    value={report.message}
                                    onChange={(e) => handleChange(e, 'message')}
                                    className="pl-0 mt-24 "
                                    rows="3"
                                    placeholder="در صورت تمایل بیشتر توضیح بدید..."/>

                                {
                                    (!isEmpty(captcha.token)) ?
                                        <Captcha
                                            handleChange={(e) => handleChange(e, 'captcha_code')}
                                            token={captcha.token}
                                            error={captcha.error}
                                            captchaValue={report.captcha}
                                            className="text-right mt-16"
                                        />
                                        : ''
                                }

                                <ButtonBase
                                    disabled={submitLoading}
                                    onClick={() => handleSubmitReport()}
                                    className="mt-16"
                                    color="secondary"
                                    block
                                >
                                    {
                                        (submitLoading) ?
                                            <CircleLoading width={24} height={24}/>
                                            :
                                            'ارسال گزارش'
                                    }
                                </ButtonBase>

                            </React.Fragment>

                            :

                            <StatusGif text={reportStatus.text} status={reportStatus.status}/>
                    }
                </Body>
            </div>
        </ModalLayout>
    );
};

export default PropertyReport;

// styles

const Body = styled.div`
  overflow-y: auto;
  max-height: calc(100vh - 14rem) !important;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    max-height: calc(100vh - 8rem) !important;
  }
`;

const ErrorDiv = styled.div`
  font-size: 14px;
`;